<template>
  <el-radio-group v-model="value" size="mini">
    <el-radio-button v-for="btn in functions" :key="btn.functionName" :label="btn.title" :name="btn.title" />
  </el-radio-group>
</template>

<script>
import { get } from 'lodash'
import { AGGREGATION_OFF } from '../lib/list-constants'

/**
 * @class RadioGroup
 *
 * @description This component renders a group of buttons from a given function list
 */
export default {
  name: 'RadioGroup',
  props: {
    activeId: {
      type: String,
      default: AGGREGATION_OFF,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    functions() {
      return get(this.options, 'functions', []).map((aggregation) => ({
        functionName: aggregation,
        title: this.$i18n.t(aggregation, { category: 'radio-group' }),
      }))
    },
    value: {
      get() {
        const value = this.functions.find((aggregation) => aggregation.functionName === this.activeId)
        return value ? value.title : AGGREGATION_OFF
      },
      set(functionTitle) {
        const value = this.functions.find((aggregation) => aggregation.title === functionTitle)
        this.$emit('change', value)
      },
    },
  },
}
</script>
